import type { SVGProps } from "react";
export interface GlobeStandIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GlobeStandIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GlobeStandIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.875 19a1.126 1.126 0 0 1 2.25 0v1.875H15l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H9a1.125 1.125 0 0 1 0-2.25h1.875zM7.13 7.019c.397-.17.888-.283 1.433-.195.553.09 1.053.367 1.482.797l.228.246a4.14 4.14 0 0 1 .566 4.552c-.315.632-.686 1.32-.943 1.94-.111.27-.173.47-.202.604a1.123 1.123 0 0 1-1.737 1.327l-.085-.078-.094-.102c-.431-.52-.364-1.167-.318-1.452.063-.388.207-.797.356-1.157.298-.721.743-1.553 1.01-2.088a1.9 1.9 0 0 0-.371-2.2c-.151-.151-.236-.166-.25-.168-.02-.004-.075-.007-.188.042-.279.12-.57.39-.888.709-.72.72-1.69.61-2.147.533-.262-.043-.534-.11-.702-.15a4 4 0 0 0-.221-.045L4 10.126l-.116-.006A1.126 1.126 0 0 1 4 7.876l.218.01c.217.02.421.068.56.1.233.052.398.095.574.124.133.022.214.024.258.023.29-.29.839-.822 1.52-1.114m2.845-5.482a1.126 1.126 0 0 1 2.092.819l-.007.14c.002.11.017.254.054.43.075.354.221.774.422 1.19s.44.792.677 1.072c.253.298.426.394.476.411.432.144.956.025 1.504-.28a4.5 4.5 0 0 0 .842-.612l.003-.003.085-.076a1.125 1.125 0 0 1 1.506 1.667l-.795-.795.795.796h-.002l-.004.005-.007.009-.025.023a6 6 0 0 1-.35.306 7 7 0 0 1-.955.646c-.717.398-1.84.83-3.062.522l-.246-.074c-.615-.205-1.114-.657-1.482-1.09-.386-.455-.721-1-.986-1.55a7.7 7.7 0 0 1-.596-1.701c-.111-.525-.173-1.172.019-1.748z"
      />
      <path
        fill={color}
        d="M19.876 9a8.83 8.83 0 0 0-1.774-5.324l.9-.675.899-.677A11.1 11.1 0 0 1 22.126 9c0 6.143-4.982 11.124-11.126 11.124a11.11 11.11 0 0 1-8.9-4.45L3 15l.899-.677A8.875 8.875 0 0 0 19.876 9m-3 0A5.876 5.876 0 0 0 5.125 9a5.875 5.875 0 0 0 11.75 0ZM2.324 14.102a1.125 1.125 0 0 1 1.575.223L2.1 15.676a1.125 1.125 0 0 1 .224-1.575Zm16-12a1.126 1.126 0 0 1 1.577.223l-1.8 1.352a1.125 1.125 0 0 1 .224-1.575Zm.802 6.9A8.125 8.125 0 0 1 11 17.125a8.125 8.125 0 1 1 0-16.25 8.126 8.126 0 0 1 8.126 8.126Z"
      />
    </svg>
  );
}
